<template>
	<section class="attestation_explain">
		<Nav title="信息授权告知书" />
		<em></em>
		<div class="content">
			<!-- <h2>信息授权告知书</h2> -->
			<p>本人 <i></i>（身份证号码：<i></i> ）授权【闪电展业】app在向本人提供产品或服务过程中，在本人的授权范围内，收集、处理、使用、共享本人的资料及个人信息，包括但不限于本人的姓名、身份证号、手机号码等个人信息。</p>
			<p>1、本人同意贵司将上述信息用于本人所明确授权的范围和用途。</p>
			<p>2、本人同意贵司将上述信息提供给第三方服务机构 ，用于对本人的身份核验，以验证本人所提供的信息的真实性。 </p>
			<p>3、本人同意第三方服务机构将本人的个人信息用于与外部数据库的比对工作，以获得验证结果。 </p>
			<p>4、本人知悉并理解，即便在贵司以及第三方服务机构具备足够的数据安全能力并提供足够的安全保护水平的前提下，本人的信息仍可能存在不可控的风险。</p>
			<p>5、本人声明，已充分理解并同意上述相关授权内容，本人自愿签署本授权书，并清晰知晓因此可能产生的一切法律后果。 </p>

			<div class="name">授权人：</div>
			<div class="time">年<i></i>月<i></i>日</div>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav"

export default {
	name: 'attestation-explain',
	components: {
		Nav,
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		
	}
}
</script>

<style lang="scss">
	.attestation_explain {
		padding-top: 46px;
		em {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #fff;
		}
		.content {
			position: relative;
			z-index: 2;
			padding: 40px 20px;
			p {
				text-indent: 28px;
				font-size: 14px;
				line-height: 30px;
				i {
					display: inline-block;
					width: 40px;
					height: 20px;
					border-bottom: 1px solid #000;
				}
			}
			.name {
				padding-top: 30px;
				font-size: 14px;
				text-align: center;
			}
			.time {
				padding-top: 10px;
				font-size: 14px;
				text-align: center;
				padding-left: 60px;

				i {
					display: inline-block;
					width: 20px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/attestation/Explain.vue